import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
export function FinalCTASection() {
  return <Section background="white" className="text-center" data-id="element-57">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-59">
          No vuelvas a quedarte sin saber qué decir
        </h2>
        <p className="text-xl text-gray-600" data-id="element-60">
          Tienes dos opciones: seguir igual, con las mismas discusiones de
          siempre, o tener a mano las palabras exactas que traen paz a tu
          relación.
        </p>
        <div className="pt-4" data-id="element-61">
          <CTAButton className="w-full md:w-auto px-12" onClick={() => window.open('https://pay.hotmart.com/H104303411I', '_blank')} data-id="element-62">
            Sí, Quiero Mejorar Mi Comunicación
          </CTAButton>
          <p className="mt-4 text-sm text-gray-400" data-id="element-63">
            Acceso inmediato a tu correo electrónico
          </p>
        </div>
      </div>
    </Section>;
}